// Available CRM fields that agents can add to any template
// These map to deal table columns for auto-fill resolution
const CUSTOM_FIELD_CATALOG = [
  { key: "budget", label: "Price / Budget", type: "money" },
  { key: "close_date", label: "Close Date", type: "date" },
  { key: "earnest_money_due", label: "Earnest Money Due", type: "date" },
  { key: "mutual_acceptance", label: "Mutual Acceptance", type: "date" },
  { key: "due_diligence", label: "Due Diligence", type: "date" },
  { key: "final_walk_through", label: "Final Walk Through", type: "date" },
  { key: "possession", label: "Possession Date", type: "date" },
  { key: "commission", label: "Commission", type: "text" },
  { key: "agent_split", label: "Agent Split", type: "text" },
  { key: "team_split", label: "Team Split", type: "text" },
  { key: "description", label: "Description", type: "text" },
  { key: "timeline", label: "Timeline", type: "text" },
  { key: "type", label: "Deal Type", type: "text" },
  { key: "earnest_money", label: "Earnest Money Amount", type: "money" },
  { key: "financing_type", label: "Financing Type", type: "text" },
  { key: "contingency_deadline", label: "Contingency Deadline", type: "date" },
  { key: "counter_amount", label: "Counter Offer Amount", type: "money" },
  { key: "counter_deadline", label: "Response Deadline", type: "date" },
  { key: "counter_terms", label: "Counter Terms", type: "text" },
  { key: "inspection_date", label: "Inspection Date", type: "date" },
  { key: "repair_credit", label: "Repair Credit", type: "money" },
  { key: "repair_items", label: "Repair Items", type: "text" },
  { key: "repair_deadline", label: "Repair Deadline", type: "date" },
  { key: "year_built", label: "Year Built", type: "text" },
  { key: "property_type", label: "Property Type", type: "text" },
  { key: "square_footage", label: "Square Footage", type: "text" },
];

export default CUSTOM_FIELD_CATALOG;
